var _path, _path2, _circle, _path3, _path4, _path5;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgCx = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#0052b4",
  d: "M0 85.333h512V426.67H0z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#6da544",
  d: "M0 85.33h512v341.332"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 256,
  cy: 255.996,
  r: 44.522,
  fill: "#ffda44"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M127.576 352.46l4.684 9.793 10.575-2.444-4.736 9.767 8.504 6.745-10.588 2.385.029 10.855-8.468-6.791-8.468 6.791.029-10.855-10.59-2.385 8.506-6.745-4.736-9.767 10.575 2.444zm-30.635-81.624l4.683 9.793 10.575-2.444-4.735 9.768 8.504 6.744-10.588 2.386.029 10.855-8.468-6.791-8.469 6.791.029-10.855-10.588-2.386 8.505-6.744-4.736-9.768 10.575 2.444zm30.635-66.782l4.684 9.792 10.575-2.444-4.736 9.768 8.504 6.744-10.588 2.386.029 10.856-8.468-6.792-8.468 6.792.029-10.856-10.589-2.386 8.504-6.744-4.735-9.768 10.575 2.444zm38.055 51.942l4.684 9.793 10.576-2.446-4.736 9.769 8.503 6.744-10.588 2.387.029 10.854-8.468-6.791-8.467 6.791.029-10.854-10.59-2.387 8.505-6.744-4.736-9.769 10.576 2.446zm-27.212 44.522l3.684 11.337h11.921l-9.644 7.007 3.684 11.337-9.645-7.006-9.643 7.006 3.684-11.337-9.645-7.007h11.921z",
  fill: "#f0f0f0"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M256 285.678h14.84s6.431-11.376 0-22.261l14.84-14.84-7.42-14.841h-7.421s-3.71 11.13-18.551 11.13c-14.841 0-18.55-11.13-18.55-11.13h-7.42l7.42 14.84-7.421 14.84 7.421 7.421s7.421-14.84 22.261-7.421c.001.001 6.309 9.276.001 22.262z",
  fill: "#6da544"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M396.449 200.819c.351-1.823.536-3.704.536-5.629 0-13.2-8.618-24.381-20.533-28.238a55.4 55.4 0 015.693 24.527c0 2.97-.239 5.882-.688 8.726a30.405 30.405 0 00-6.91-7.768c-10.601-8.435-25.087-8.658-35.797-1.554a56.86 56.86 0 0123.335 11.102c5.536 4.405 10.01 10.364 13.434 16.116l-45.316 14.19c44.522 7.421 81.623-22.261 81.623-22.261-4.11-8.221-10.496-9.606-15.377-9.211z",
  fill: "#ffda44"
})));

export default SvgCx;